<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2EK9di/tc-custom/9780253001276.jpg?1736600911180" alt="This image is the cover for the book Contributions to Philosophy, Studies in Continental Thought"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Contributions to Philosophy, Studies in Continental Thought
      </h1>
      <p class="bookDescription body article font2">
        <b>Heidegger’s second magnum opus after <i>Being and Time</i>, laying the groundwork for his later writing, in a translation of “impeccable clarity and readability” (Peter Warnek).</b><br/>  <br/> Martin Heidegger’s <i>Contributions to Philosophy</i>, written in the late 1930s and published posthumously in 1989, is now widely viewed as his second magnum opus, after <i>Being and Time</i>. Here, Heidegger lays the groundwork for a new conception of thought and being, rooting them both in the event of appropriation. Here, Heidegger establishes the language and intellectual framework necessary for all of his later writings.<br/>  <br/><i>Contributions</i> was composed as a series of private ponderings that were not originally intended for publication. They are nonlinear and radically at odds with the traditional understanding of thinking. This translation presents Heidegger in plain and straightforward terms, allowing surer access to this new turn in Heidegger’s conception of being.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martin Heidegger, Richard Rojcewicz
      </h2>
      
      <p class="authorDescription body article">Heidegger&rsquo;s contribution to the growth and development of National Socialism was immense. In this small anthology, Dr. Runes endeavors to point to the utter confusion Heidegger created by drawing, for political and social application of his own existentialism and metaphysics, upon the decadent and repulsive brutalization of Hitlerism.<BR /><BR /> Martin Heidegger was a philosopher most known for his contributions to German phenomenological and existential thought. Heidegger was born in rural Messkirch in 1889 to Catholic parents. While studying philosophy and mathematics at Albert-Ludwig University in Freiburg, Heidegger became the assistant for the philosopher Edmund Husserl. Influenced by Husserl, Kierkegaard, and Nietzsche, Heidegger wrote extensively on the quality of Being, including his Opus <I>Being and Time</I>. He served as professor of philosophy at Albert-Ludwig University and taught there during the war. In 1933, Heidegger joined the National Socialist German Worker&rsquo;s (or Nazi) Party and expressed his support for Hitler in several articles and speeches. After the war, his support for the Nazi party came under attack, and he was tried as a sympathizer. He was able to return to Albert Ludwig University, however, and taught there until he retired. Heidegger continued to lecture until his death in 1973.&#160;<br clear="all" /><BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f043ecd8